export const TODOS_TOOLTIP_MESSAGE =
  "To-dos are ordered by priority and then by due date, with the earliest due dates first. Students will see to-dos in this same order.";
